import { formatDateTime } from '@formosa/shared/utils/formatDateTime';

export const MEMBER_ROLE_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '正常帳號' },
  { value: '2', label: '試玩帳號' },
];

export const MEMBER_ROLE_LABELS = {
  1: '正常帳號',
  2: '試玩帳號',
  3: '測試帳號',
};

export const MEMBER_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '正常' },
  { value: '0', label: '禁用' },
];

export const MEMBER_ORDER_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '正常' },
  { value: '0', label: '禁止' },
];

export const MEMBER_SOURCE_LABELS = {
  1: '會員註冊',
  2: '後台添加',
};

export const PAGE_SIZE = 15;

/** 平台根會員 ID（預設上級，後台可見但受保護） */
export const PLATFORM_ROOT_MEMBER_ID = 1;

export function isPlatformRootMember(memberId) {
  return Number(memberId) === PLATFORM_ROOT_MEMBER_ID;
}

export const EMPTY_FILTERS = {
  roleId: '',
  status: '',
  allowOrder: '',
  memberIds: '',
  countryCode: '',
  emailOrPhone: '',
  trialMemberId: '',
  promotionCode: '',
  inviterId: '',
  topInviterId: '',
  lastLoginIp: '',
  registerIp: '',
  withdrawAddress: '',
  memberLevel: '',
  balanceMin: '',
  balanceMax: '',
  registrationStartInput: '',
  registrationEndInput: '',
};

export function formatOptionalId(value) {
  if (value == null || value === '') {
    return '—';
  }
  return String(value);
}

export function formatAmount(value) {
  if (value == null || value === '') {
    return '—';
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return String(value);
  }
  return num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 6 });
}

export function formatRoleId(roleId) {
  return MEMBER_ROLE_LABELS[roleId] || roleId || '—';
}

export function formatMemberStatus(status) {
  if (status === 1) {
    return '正常';
  }
  if (status === 0) {
    return '禁用';
  }
  return '—';
}

export function formatAllowOrder(allowOrder) {
  if (allowOrder === 1) {
    return '正常';
  }
  if (allowOrder === 0) {
    return '禁止';
  }
  return '—';
}

export function formatYesNo(value) {
  if (value === 1 || value === true) {
    return '是';
  }
  if (value === 0 || value === false) {
    return '否';
  }
  return '—';
}

export function formatMemberSource(source) {
  return MEMBER_SOURCE_LABELS[source] || source || '—';
}

export function formatKycName(row) {
  const parts = [row?.lastName, row?.realName].filter(Boolean);
  return parts.length ? parts.join(' ') : '—';
}

export function formatContact(row) {
  return row?.email || row?.mobile || row?.username || '—';
}

export function toQueryDateTime(input) {
  if (!input) {
    return undefined;
  }
  const normalized = String(input).length === 16 ? `${input}:00` : input;
  return normalized.replace('T', ' ');
}

export function parseMemberIdsInput(raw) {
  if (!raw || !String(raw).trim()) {
    return undefined;
  }
  const ids = String(raw)
    .split(/[,，\s]+/)
    .map((item) => Number(item.trim()))
    .filter((id) => !Number.isNaN(id) && id > 0);
  return ids.length ? ids : undefined;
}

export function buildMemberPageParams(pageNo, filters, pageSize = PAGE_SIZE) {
  const params = {
    pageNo,
    pageSize,
  };
  if (filters.roleId) {
    params.roleId = filters.roleId;
  }
  if (filters.status !== '') {
    params.status = Number(filters.status);
  }
  if (filters.allowOrder !== '') {
    params.allowOrder = Number(filters.allowOrder);
  }
  const ids = parseMemberIdsInput(filters.memberIds);
  if (ids?.length === 1) {
    params.ids = ids;
  } else if (ids?.length > 1) {
    params.ids = ids;
  }
  if (filters.emailOrPhone?.trim()) {
    params.emailOrPhone = filters.emailOrPhone.trim();
  }
  if (filters.promotionCode?.trim()) {
    params.promotionCode = filters.promotionCode.trim();
  }
  if (filters.inviterId) {
    params.inviterId = Number(filters.inviterId);
  }
  if (filters.topInviterId) {
    params.topInviterId = Number(filters.topInviterId);
  }
  if (filters.lastLoginIp?.trim()) {
    params.lastLoginIp = filters.lastLoginIp.trim();
  }
  if (filters.registerIp?.trim()) {
    params.registerIp = filters.registerIp.trim();
  }
  if (filters.balanceMin !== '') {
    params.balanceMin = filters.balanceMin;
  }
  if (filters.balanceMax !== '') {
    params.balanceMax = filters.balanceMax;
  }
  const registrationStart = toQueryDateTime(filters.registrationStartInput);
  const registrationEnd = toQueryDateTime(filters.registrationEndInput);
  if (registrationStart) {
    params.registrationStart = registrationStart;
  }
  if (registrationEnd) {
    params.registrationEnd = registrationEnd;
  }
  return params;
}

export function formatDateCell(value) {
  return value ? formatDateTime(value) : '—';
}
